import {
  fork,
  put,
  all,
  call,
  takeLatest,
} from "redux-saga/effects";

import {
  GET_ORGANIZATION_IAAC,
  POST_ORGANIZATION_IAAC,
  PUT_ORGANIZATION_IAAC,
  DELETE_ORGANIZATION_IAAC,
  CLEAR_ALL_ORGANIZATION_IAAC_MESSAGES,
} from "./actionTypes";

import { 
  getOrganizationIaacSuccessful,
  getOrganizationIaacFailure,
  postOrganizationIaacSuccessful,
  postOrganizationIaacFailure,
  putOrganizationIaacSuccessful,
  putOrganizationIaacFailure,
  deleteOrganizationIaacSuccessful,
  deleteOrganizationIaacFailure,
  clearAllOrganizationIaacMessagesSuccessful as clearAllOrganizationIaacMessagesSuccessfulAction
} from "./actions";

import {
  getOrganizationIaac as getOrganizationIaacApi,
  postOrganizationIaac as postOrganizationIaacApi,
  putOrganizationIaac as putOrganizationIaacApi,
  deleteOrganizationIaac as deleteOrganizationIaacApi,
} from "../../helpers/auth_helper";

function* getOrganizationIaac({payload: { orgCode } }) {
  try {
    const response = yield call(getOrganizationIaacApi, orgCode);
    console.log("getOrganizationIaacApi Response: ", response);
    if( response && response.status === 200 ){
      delete response.status;
      yield put(getOrganizationIaacSuccessful(response));
    }
    else {
      let message;
      if(response.message) {
        message = response.message;
      } else {
        message = response;
      }
      yield put(getOrganizationIaacFailure({ message: message }));
    }
  } catch (error) {
    console.log("getOrganizationIaacApi Error: ", error);
    if(error.response){
      yield put(getOrganizationIaacFailure({message: "Error Code: "+error.response?.status+", Message: "+error.response?.data}));
    } else if(error.request){
      yield put(getOrganizationIaacFailure({message: "No response is received"}))
    } else{
      yield put(getOrganizationIaacFailure({message: error?.message}));
    }
  }
}

function* createOrganizationIaac({payload: { orgCode, iaacRequest } }) {
  // console.log("Saga, createOrganizationIaac, orgCode: ", orgCode, " iaacRequest: ", iaacRequest);
  try {
    const response = yield call(postOrganizationIaacApi, orgCode, iaacRequest);
    console.log("postOrganizationIaacApi Response: ", response);
    if( response && response.status === 200 ){
      delete response.status;
      yield put(postOrganizationIaacSuccessful(response));
    } else {
      let message;
      if(response.message) {
        message = response.message;
      } else {
        message = response;
      }
      yield put(postOrganizationIaacFailure({ message: message }));
    }
  } catch (error) {
    console.log("postOrganizationIaacApi Error: ", error);
    if(error.response){
      yield put(postOrganizationIaacFailure({message: "Error Code: "+error.response?.status+", Message: "+error.response?.data}));
    } else if(error.request){
      yield put(postOrganizationIaacFailure({message: "No response is received"}))
    } else{
      yield put(postOrganizationIaacFailure({message: error?.message}));
    }
  }
}

function* updateOrganizationIaac({payload: { orgCode, iaacRequest, subscriptionChange } }) {
  try {
    const response = yield call(putOrganizationIaacApi, orgCode, iaacRequest, subscriptionChange);
    console.log("putOrganizationIaacApi Response: ", response);
    if( response && response.status === 200 ){
      delete response.status;
      yield put(putOrganizationIaacSuccessful(response.data));
    } else {
      let message;
      if(response.message) {
        message = response.message;
      } else {
        message = response;
      }
      yield put(putOrganizationIaacFailure({ message: message }));
    }
  } catch (error) {
    console.log("putOrganizationIaacApi Error: ", error);
    if(error.response){
      yield put(putOrganizationIaacFailure({message: "Error Code: "+error.response?.status+", Message: "+error.response?.data}));
    } else if(error.request){
      yield put(putOrganizationIaacFailure({message: "No response is received"}))
    } else{
      yield put(putOrganizationIaacFailure({message: error?.message}));
    }
  }
}

function* deleteOrganizationIaac({payload: { orgCode } }) {
  console.log("Saga, deleteOrganizationIaac, orgCode: ", orgCode);
  try {
    const response = yield call(deleteOrganizationIaacApi, orgCode);
    console.log("deleteOrganizationIaacApi Response: ", response);
    if( response && response.status === 200 ){
      delete response.status;
      yield put(deleteOrganizationIaacSuccessful(response.data));
    } else {
      let message;
      if(response.message) {
        message = response.message;
      } else {
        message = response;
      }
      yield put(deleteOrganizationIaacFailure({ message: message }));
    }
  } catch (error) {
    console.log("deleteOrganizationIaacApi Error: ", error);
    if(error.response){
      yield put(deleteOrganizationIaacFailure({message: "Error Code: "+error.response?.status+", Message: "+error.response?.data}));
    } else if(error.request){
      yield put(deleteOrganizationIaacFailure({message: "No response is received"}))
    } else{
      yield put(deleteOrganizationIaacFailure({message: error?.message}));
    }
  }
}

export function* clearAllOrganizationIaacMessages() {
  console.log("organizationIaac Saga: clear all messages");
  yield put(clearAllOrganizationIaacMessagesSuccessfulAction());
}

function* watchOrganizationIaac() {
  yield takeLatest(GET_ORGANIZATION_IAAC, getOrganizationIaac);
  yield takeLatest(POST_ORGANIZATION_IAAC, createOrganizationIaac);
  yield takeLatest(PUT_ORGANIZATION_IAAC, updateOrganizationIaac);
  yield takeLatest(DELETE_ORGANIZATION_IAAC, deleteOrganizationIaac);
  yield takeLatest(CLEAR_ALL_ORGANIZATION_IAAC_MESSAGES, clearAllOrganizationIaacMessages);
}

function* organizationIaacSaga() {
  yield all([fork(watchOrganizationIaac)])
}

export default organizationIaacSaga;